import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Produto } from 'src/app/models/compra/produto.model';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProdutoService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  getProdutos(): Observable<Produto[]> {
    return this.http.get<Produto[]>(`${URL_GLOBAL}/produtos`);
  }
  save(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/produtos`, data);
  }

  find(id: any): Observable<any> {
    return this.http.get(`${`${URL_GLOBAL}/produtos`}/${id}`);
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${`${URL_GLOBAL}/produtos`}/${id}`, data);
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/produtos`}/${id}`);
  }

  busca_produto(codigo: any): Observable<any> {
    return this.http.get(`${`${URL_GLOBAL}/produtos`}?codigo=${codigo}`);
  }
  PegarTodosOsRegistrosPorIdDaEmpresa(param: any): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/produtos`, {
      params: new HttpParams().append('commands', JSON.stringify(param)),
    });
  }
  PegarTodosOsRegistrosPorIdDaEmpresa2(
    url: any,
    param: any
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${url
        ? url + '&paginate=1'
        : `${URL_GLOBAL}/web/compras/produtos?paginate=1`
      }&categoria=${param.categoria ? param.categoria : ''}&descricao=${param.descricao ? param.descricao : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  // Autenticado //
  getAllProdutosByIdEmpresa(params?): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/compras/produtos/getAllProdutosByIdEmpresa?tabela=${params ? params : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  buscaProdutoPorCodigo(token, codigo): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/produtos/buscaProdutoPorCodBarra?codigobarra=${codigo}`,
      { headers }
    );
  }
  buscaLocalizacaoProdutos(token): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/produtos/localizacaoOfProdutos`,
      { headers }
    );
  }
  movimentacaoEstoque(param, token: any): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/estoque/movimentacaoEstoque?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers }
    );
  }

  salvaProdutosImportados(data: any, token: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.post<any>(
      `${URL_GLOBAL}/web/produtos/salvaProdutosImportados`,
      data,
      { headers }
    );
  }
  uploadBrasindice(doc, file: any) {
    const formData: FormData = new FormData();
    formData.append('version', doc.version);
    if (file) {
      formData.append('file', doc.arquivos[0].file, doc.arquivos[0].file.name);
    } else {
      formData.append('file', '');
    }
    return this.http.post<any>(
      `${URL_GLOBAL}/products/import/brasindice`,
      formData,
      { headers: this.authService.userToken() }
    );
  }
  uploadSimpro(doc, file: any) {
    const formData: FormData = new FormData();
    formData.append('version', doc.version);
    if (file) {
      formData.append('file', doc.arquivos[0].file, doc.arquivos[0].file.name);
    } else {
      formData.append('file', '');
    }
    return this.http.post<any>(
      `${URL_GLOBAL}/products/import/simpro`,
      formData,
      { headers: this.authService.userToken() }
    );
  }
  getTabelas(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/tabelas/list`, {
      headers: this.authService.userToken(),
    });
  }

  //filtra os produtos
  getProductsFilter(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/products/filter?version=${param.version ? param.version : ''
      }&description=${param.description ? param.description : ''}&table_type=${param.table_type ? param.table_type : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  // Rotas novas para Products
  getProductsToCompany(url: any, param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${url ? url + '&paginate=1' : `${URL_GLOBAL}/products-company?paginate=1`
      }&description=${param.description ? param.description : ''}&table=${param.table ? param.table : ''}&category_id=${param.category_id ? param.category_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  saveProduct(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/product`, data, {
      headers: this.authService.userToken(),
    });
  }

  getAllVersionFromTable(table: string): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/product-versions/${table}`, {
      headers: this.authService.userToken(),
    });
  }

  getProductFromTableVersion(
    table: string,
    version: string,
    client_id?: number
  ): Observable<any> {
    return this.http.get<any>(
      `${URL_GLOBAL}/product-versions/${table}/${version}${client_id ? `?client_id=${client_id}` : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  productsCompanyById(client_id?: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/products-company-by-id${client_id ? `?client_id=${client_id}` : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  // salva o produto, na tabela de produtos por emrpesa
  productsCompanyBind(data: any, all: boolean): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/products-company/bind/${all}`, data, {
      headers: this.authService.userToken(),
    });
  }
  updateProduct(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${`${URL_GLOBAL}/product`}/${id}`, data, {
      headers: this.authService.userToken(),
    });
  }
  updatProductCategory(id: any, category_id: any): Observable<any> {
    return this.http.put<any>(
      `${URL_GLOBAL}/product/updateCateogory/${id}`,
      category_id,
      { headers: this.authService.userToken() }
    );
  }
  findProduct(id: any): Observable<any> {
    return this.http.get(`${`${URL_GLOBAL}/product`}/${id}`, {
      headers: this.authService.userToken(),
    });
  }
  deleteProductsToCompany(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/productsToCompany`}/${id}`, {
      headers: this.authService.userToken(),
    });
  }

  removeSupplier(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/remove-supplier`}/${id}`, {
      headers: this.authService.userToken(),
    });
  }
}
